import './bootstrap.scss'

// give Webpack some “breathing room”
// to be able to asynchronously load any dependencies required by Module Federation.
import('./bootstrap')
export {}
